import { AxiosInstance } from "axios";
import { ApiService } from '../model/Api.model';
import { IUnreconciledSettlement } from '../interface/settlements/IUnreconcileSettlement';
import { IReconcileSettlementRequest } from '../interface/settlements/IReconcileSettlementRequest';
import { IReconciledSettlement } from '../interface/settlements/IReconciledSettlement';
import { ReconcileSettlementStatusEnum } from '../enum/settlements/ReconcileSettlementStatusEnum';
import { IRevertReconciledSettlement } from "../interface/settlements/IRevertReconciledSettlement";

enum SettlementsServiceEnum {
  reconcile = "/reconcile",
  reconcileds = "/reconcileds",
  unreconcileds = "/unreconcileds",
  trades = "/trades",
  acceptNegativeSpread = "/accept-negative-spread",
  updateReconcile = "/update-reconcile",
  rejectReconcile = "/reject-reconcile",
  revertReconcile = "/revert"
}

export default class SettlementsService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/settlements");
  }

  public getAllReconcileds = async (): Promise<IReconciledSettlement[]> => await this.GET(SettlementsServiceEnum.reconcileds);
  public getAllUnreconcileds = async (): Promise<IUnreconciledSettlement[]> => await this.GET(SettlementsServiceEnum.unreconcileds);
  public getUnreconciledTradeIds = async (): Promise<number[]> => await this.GET(SettlementsServiceEnum.trades);
  public getReconcileByStatus = async (status: ReconcileSettlementStatusEnum): Promise<IReconciledSettlement[]> => await this.GET(`${SettlementsServiceEnum.reconcile}/${status}`);
  public acceptNegativeSpread = async (id: number): Promise<void> => await this.POST(`${SettlementsServiceEnum.acceptNegativeSpread}/${id}`);
  public rejectReconcile = async (id: number): Promise<void> => await this.POST(`${SettlementsServiceEnum.rejectReconcile}/${id}`);
  public revertReconcile = async (dto: IRevertReconciledSettlement): Promise<string> => await this.POST(`${SettlementsServiceEnum.revertReconcile}`, dto, "text");
  public reconcile = async (reconcileSettlement: IReconcileSettlementRequest): Promise<void> =>
    await this.POST(
      SettlementsServiceEnum.reconcile,
      reconcileSettlement
    );

  public reconcileUpdate = async (reconcileSettlement: IReconciledSettlement): Promise<void> =>
    await this.POST(
      SettlementsServiceEnum.updateReconcile,
      reconcileSettlement
    );
}
